import { IDomain } from "../components/types/genericTypes";
const subDomainUrl: Array<string> = process.env.PUBLIC_URL.split("/");

const dev: IDomain = {
  root: "http://localhost:3001/",
  web_mw: "https://nwmwuat.nuvamawealth.com/EWMTrade/api/",
  web_reports: "https://nwmwuat.nuvamawealth.com/EWReports/api/",
  moui: "https://nmwuat1.nuvamawealth.com/edelms-accounts-uat/",
  moui_penny_drop: "https://nmwuat1.nuvamawealth.com/edelmw-login-uat/login/service/request/",
  streamUrl: "wss://ewstream.edelweiss.in/",
  jmw: "https://nmwuat1.nuvamawealth.com/",
  jmw_eq: "edelmw-eq-uat/",
  jmw_eq_eq: "edelmw-eq-uat/eq/",
  jmw_comm: "edelmw-comm-uat/comm/",
  jmw_mf: "edelmw-mf-uat/mf/",
  jmw_sr: "edelmw-sr-uat/servicerequest/",
  jmw_nse: "edelmw-nse-uat/nse/",
  jmw_content: "edelmw-content-uat/content/",
  jmw_login: "edelmw-login-uat/login/",
  tradeService: "trade/",
  edelService: "edel/",
  client_Id: "E517209A",
  reDirectUrl: "https://vamauat.nuvamawealth.com/app/showDocuments",
  whatsapp_consent:
    "https://nmwuat1.nuvamawealth.com/communication-uat/whatsapp/consent",
  appId: "9e5481c0130b8bba8190e52bdc5038ba",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTkwOTg1Njg1LCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2MjI1MjE5ODUsImlhdCI6MTU5MDk4NTk4NX0.6jabTWX6dFXyX4RNAcD1kggLZIyv33Xeauxe00Z4-38",
  rootUrl: "http://localhost:5147/",
};

const uat: IDomain = {
  root: "https://vamauat.nuvamawealth.com/gamma/",
  web_mw: "https://nwmwuat.nuvamawealth.com/EWMTrade/api/",
  web_reports: "https://nwmwuat.nuvamawealth.com/EWReports/api/",
  moui: "https://nmwuat1.nuvamawealth.com/edelms-accounts-uat/",
  moui_penny_drop: "https://nmwuat1.nuvamawealth.com/edelmw-login-uat/login/service/request/",
  streamUrl: "wss://ewstream.edelweiss.in/",
  jmw: "https://nmwuat1.nuvamawealth.com/",
  jmw_eq: "edelmw-eq-uat/",
  jmw_eq_eq: "edelmw-eq-uat/eq/",
  jmw_comm: "edelmw-comm-uat/comm/",
  jmw_mf: "edelmw-mf-uat/mf/",
  jmw_sr: "edelmw-sr-uat/servicerequest/",
  jmw_nse: "edelmw-nse-uat/nse/",
  jmw_content: "edelmw-content-uat/content/",
  jmw_login: "edelmw-login-uat/login/",
  tradeService: "trade/",
  edelService: "edel/",
  appId: "9e5481c0130b8bba8190e52bdc5038ba",
  client_Id: "E517209A",
  reDirectUrl: "https://vamauat.nuvamawealth.com/gamma/app/showDocuments",
  whatsapp_consent:
  "https://nmwuat1.nuvamawealth.com/communication-uat/whatsapp/consent",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTkwOTg1Njg1LCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2MjI1MjE5ODUsImlhdCI6MTU5MDk4NTk4NX0.6jabTWX6dFXyX4RNAcD1kggLZIyv33Xeauxe00Z4-38",
  rootUrl:
    "https://vamauat.nuvamawealth.com/" +
    (subDomainUrl.length > 2 ? subDomainUrl[1] + "/" : ""),
};

const cug: IDomain = {
  root: "https://vamacug.nuvamawealth.com/",
  web_mw: "https://nwmwcug.nuvamawealth.com/api/",
  web_reports: "https://nwmwcug.nuvamawealth.com/ewreportscug/api/",
  moui: "https://nmwcug.nuvamawealth.com/edelmw-ao-cug/",
  moui_penny_drop: "https://nmwcug.nuvamawealth.com/edelmw-login-cug/login/service/request/",
  streamUrl: "wss://nwst.nuvamawealth.com/",
  jmw: "https://nmwcug.nuvamawealth.com/",
  jmw_eq: "edelmw-eq-cug/",
  jmw_eq_eq: "edelmw-eq-cug/eq/",
  jmw_comm: "edelmw-comm-cug/comm/",
  jmw_mf: "edelmw-mf-cug/mf/",
  jmw_sr: "edelmw-sr-cug/servicerequest/",
  jmw_nse: "edelmw-nse-cug/nse/",
  jmw_content: "edelmw-content-cug/content/",
  jmw_login: "edelmw-login-cug/login/",
  tradeService: "trade-services/",
  edelService: "edel-services/",
  appId: "4fe68b7536784e3407c3ecf19be7c4ad",
  client_Id: "FD8066A1",
  reDirectUrl: "https://vamacug.nuvamawealth.com/app/showDocuments",
  whatsapp_consent: "https://nmwcug.nuvamawealth.com/communication/whatsapp/consent",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
  rootUrl: "https://vamacug.nuvamawealth.com/",
};

const prod: IDomain = {
  root: "https://www.nuvamawealth.com/",
  web_mw: "https://nwmw.nuvamawealth.com/api/",
  web_reports: "https://nwmw.nuvamawealth.com/ewreports/api/",
  moui: "https://nw.nuvamawealth.com/edelmw-ao/",
  moui_penny_drop: "https://nw.nuvamawealth.com/edelmw-login/login/service/request/",
  streamUrl: "wss://nwst.nuvamawealth.com/",
  jmw: "https://nw.nuvamawealth.com/",
  jmw_eq: "edelmw-eq/",
  jmw_eq_eq: "edelmw-eq/eq/",
  jmw_comm: "edelmw-comm/comm/",
  jmw_mf: "edelmw-mf/mf/",
  jmw_sr: "edelmw-sr/servicerequest/",
  jmw_nse: "edelmw-nse/nse/",
  jmw_content: "edelmw-content/content/",
  jmw_login: "edelmw-login/login/",
  tradeService: "trade-services/",
  edelService: "edel-services/",
  appId: "4fe68b7536784e3407c3ecf19be7c4ad",
  client_Id: "FD8066A1",
  reDirectUrl: "https://www.nuvamawealth.com/app/showDocuments",
  whatsapp_consent: "https://nw.nuvamawealth.com/communication/whatsapp/consent",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
  rootUrl:
    "https://www.nuvamawealth.com/" +
    (subDomainUrl.length > 2 ? subDomainUrl[1] + "/" : ""),
};

export const config: IDomain =
  process.env.REACT_APP_ENV === "production" ? prod : process.env.REACT_APP_ENV === "uat" ? uat : dev;
const configURL = {
  market: {
    status: config.web_mw + "Market/Process/GetMarketStatus/",
    root: config.web_mw + "Market/Process/",
    market: config.web_mw + "Market/",
  },
usd:{
  status: config.web_mw + "Market/MarketsModule/overview",
},
banknifty:{
  status: config.web_mw + "Market/MarketsModule/MarketsIndices",
},
  // whatsapp_consent: config.jmw + "frontend/communication-uat/whatsapp/consent",
  getNomineeDetails: config.jmw + config.jmw_login + "sr/getnomineedetails",
  createServiceReqNomin: config.jmw + config.jmw_login + "sr/nominate",
  downloadPrefilledNominatinForm: config.jmw + config.jmw_login + "sr/nominate/prefilled-pdf/",
  feedback: config.web_mw + "feedback/",
  merceApiUrl: config.web_mw + "gba/",
  streamUrl: config.streamUrl,
  root: config.root,
  appidkey: config.appIdKey,
  appid: config.appId,
  web_mw: config.web_mw,
  web_reports: config.web_reports,
  profile: {
    personalDetails: config.web_mw + "Profile/GetPersonalDetails",
    personalDetailsCOM: config.web_mw + "Profile/GetComPersonalDetails",
    ClientProfilePicture: config.web_mw + "Profile/GetClientProfilePicture",
    ServicingDetails: config.web_mw + "Profile/GetServicingDetails",
    ServicingDetailsCOM: config.web_mw + "Profile/GetComServicingDetails",
    clientDetails: config.web_mw + "Profile/ClientDetails/",
    POADownloadDetails: config.web_mw + "Profile/GetPOAAdditionFile",
    POAFlagDetails: config.web_mw + "Profile/GetValidateDetailsSegment",
    CreateServiceRequest: config.web_mw + "Profile/CreateServiceRequestDetails",
    checkValidation: config.web_mw + "Profile/ServiceClientValidation",
    getDPID: config.web_mw + "Profile/GetDPIDsAccount",
    ExistingIncomeRange: config.web_mw + "Profile/GetExistingIncomeRange",
    NewIncomeRange: config.web_mw + "Profile/GetNewIncomeRange",
    DepositoryDetail: config.web_mw + "Profile/GetDepositoryDetails",
    ServiceClientValidation: config.web_mw + "Profile/ServiceClientValidation",
    ServiceSchemeValidation: config.web_mw + "Profile/ServiceSchemeValidation",
    GetMessageDetails: config.web_mw + "Profile/GetMyMessageDetails",
    GetMessageDetailsCOM: config.web_mw + "Profile/GetComMessageDetails",
    GetServiceRequest: config.web_mw + "Profile/GetServiceDetails/",
    GetServiceRequestCOM: config.web_mw + "Profile/GetComServiceDetails",
    bankDetails: config.web_mw + "Profile/GetBankDetails",
    BrokerageSlabDetails: config.web_mw + "Profile/GetBrokerageSlab",
    GetCKYCValidation: config.web_mw + "Profile/GetCKYCValidation",
    adharVerify: config.web_mw + "Profile/checkPanAddharLink",
    FatcaValidation: config.web_mw + "Profile/GetFatcaValidation",
    CountryDetail: config.web_mw + "Profile/GetCountryDetails",
    DematAcctValidation: config.web_mw + "profile/ServiceDematAcctValidation/",
    FamilyRelationshipList: config.web_mw + "Profile/GetFamilyRelationshipListDetails",
    FamilyDeclarationList: config.web_mw + "Profile/GetFamilyDeclarationList",
    GetPreFilledFormPDF: config.web_mw + "Profile/GetPreFilledFormPDF",
    GetEsignUrl: config.web_mw + "Profile/GetEsignUrl",
    GetEsignUrlV2: config.web_mw + "Profile/EsignPiChainUrl",
    GetEsignStatus: config.web_mw + "Profile/EsignPiChainStatus",
    DownloadEsignDocument: config.web_mw + "Profile/DownloadEsignDocument",
    DownloadEsignDocumentV2: config.web_mw + "Profile/EsignPiChainDownload",
    GetEquityReactivationClientValidation: config.web_mw + "Profile/GetEquityReactivationClientValidation",
    CreateChildServiceRequestDetails: config.web_mw + "Profile/CreateChildServiceRequestDetails",
    GetAllNewExistingSRDetails: config.web_mw + "Profile/GetAllNewExistingSRDetails",
    getMergeDocument: config.web_mw + "Profile/MargeMultipleImagestoPDF",
    getSelectedDocument: config.web_reports + "common/1.2/GetSelectedDocumentXML",
    createSRDocumentUpload: config.web_mw + "Profile/createSRDocumentUpload",
    fetchDigiLockerUrl: config.web_mw + "Profile/GetDigilockerUrl",
    fetchDigiLockerDetails: config.web_mw + "Profile/GetDigilockerDetails",
    getMemorandumDetails: config.web_mw + "Profile/GetMemorandumDetails",
    createChildSR: config.web_mw + "Profile/CreateChildServiceRequestDetails",
    updatAccReactStatus: config.web_mw + "Profile/UpdateAccountReactivationStatus",
    getDefaultBankValidationDetails: config.web_mw + "Profile/GetDefaultBankValidationDetails/",
    GetEquityDormantClientCategoryValidation: config.web_mw + "Profile/GetEquityDormantClientCategoryValidation",
  },
  sr: {
    getDpDetails: config.jmw + config.jmw_login + "sr/dpdetails",
    accClosureValidate: config.jmw + config.jmw_login + "sr/account/validate",
    otpSend: config.jmw + config.jmw_sr + "sr/send/otp",
    otpValidate: config.jmw + config.jmw_sr + "sr/validate/otp",
    accClosureSR: config.jmw + config.jmw_login + "sr/account/close",
    esignUrlJMW: config.jmw + config.jmw_login + "sr/esign/url",
    esignStatusJMW: config.jmw + config.jmw_login + "sr/esign/status",
    esignDownloadJMW: config.jmw + config.jmw_login + "sr/esign/download",
    getServiceDet: config.jmw + config.jmw_login + "sr/getservicedetails",
    getDdpiDetails: config.jmw + config.jmw_login + "sr/ddpi/details",
    getDdpiValidation: config.jmw + config.jmw_login + "sr/ddpi/validate/",
    createDdpiSR: config.jmw + config.jmw_login + "sr/ddpi/",
    ddpiPreFilledFormPDF: config.jmw + config.jmw_login + "sr/ddpi/prefilled/form",
    getSMTFValidation: config.jmw + config.jmw_login + "sr/smtf/validate",
    createSMTFSR: config.jmw + config.jmw_login + "sr/smtf",
    createSegmentDeactivation: config.jmw + config.jmw_sr + "sr/create-segment-deactivation-sr",
    validateSegDeactivation: config.jmw + config.jmw_sr + "sr/validate-segment-deactivation",
    getSegmentsDetails: config.jmw + config.jmw_sr + "sr/get-account-segments",
    BrokerageSlabDetails: config.jmw + config.jmw_sr + "sr/brokerage-slab",
    validateSegActivation: config.jmw + config.jmw_sr + "sr/validate-segment",
    createSegmentActivation: config.jmw + config.jmw_sr + "sr/segment-activation"    
  },
  account: {
    GenerateOtp: config.web_mw + "Account/GenerateOTP",
    VerifyOtp: config.web_mw + "Account/ValidateOTP",
    adharVerify: config.web_mw + "Profile/checkPanAddharLink",
  },
  fund: {
    getBankDetails: config.jmw + config.jmw_eq_eq + "fund/bankdetails/v2",
    paymentGateway: config.jmw + config.jmw_eq_eq + "fund/paymentgatewayurl/v1/",
  },
  GSearch: {
    GetSearchRedirectResult: config.web_reports + "search/gsa/GetSearchRedirectResult", //POST
    GSearchSuggestions: config.web_reports + "search/gsa/suggestions", //POST
  },
  rootUrl: config.rootUrl,
  smallcaseUrl: "https://edelweiss.smallcase.com/",
  orderBook: {
    eq: config.jmw + config.jmw_eq_eq + "order/book/",
    eqHistory: config.jmw + config.jmw_eq_eq + "order/history/",
    eqSip: config.jmw + config.tradeService + "EQSIP/EQSIPBook/1.0.0",
    eqOrderLog: config.jmw + config.jmw_eq_eq + "order/details/",
    eqCancelNrmOrd: config.jmw + config.jmw_eq_eq + "trade/canceltrade/v1/",
    eqCancelAmoOrd: config.jmw + config.jmw_eq_eq + "trade/amo/canceltrade/v1/",
    eqCancelSIPOrd: config.jmw + config.tradeService + "EQSIP/CancelSIP/1.0.0",
    eqConvertPos: config.jmw + config.jmw_eq_eq + "trade/convertposition/v1/",
    eqtradeBook: config.jmw + config.jmw_eq_eq + "tradebook/v1",
    commodity: config.jmw + config.jmw_comm + "orderbook/",
    commCancelNrmOrd: config.jmw + config.jmw_comm + "trade/canceltrade/v1/",
    commCancelAmoOrd: config.jmw + config.jmw_comm + "trade/amo/canceltrade/v1/",
    commOrderLog: config.jmw + config.jmw_comm + "orderdetails/",
    commtradeBook: config.jmw + config.jmw_comm + "tradebook/",
    commodityHist: config.jmw + config.jmw_comm + "orderhistory/",
    commConvertPos: config.jmw + config.jmw_eq_eq + "trade/convertposition/v1/",
    mf: config.jmw + config.jmw_mf + "order/",
    mfSip: config.jmw + config.jmw_mf + "order/sip/",
    mfCancelNrmOrd: config.jmw + config.jmw_mf + "trade/",
    mfCancelHoldOrd: config.jmw + config.jmw_mf + "trade/hold/",
    ipo: config.jmw + config.jmw_nse + "ipo/orderstatus",
    ofs: config.jmw + config.tradeService + "OFS/OFSOrderBook/1.0.0",
    ncd: config.jmw + config.tradeService + "IPO/IPOOrderBook/1.0.0",
    nfo: config.jmw + config.jmw_mf + "order/nfo/",
    ipoCancelOrd: config.jmw + config.jmw_mf + "ipo/cancel",
  },
  position: {
    eq: config.jmw + config.jmw_eq_eq + "positions/net/",
    eq2: config.jmw + config.jmw_eq_eq + "positions/net/interop/",
    commodity: config.jmw + config.jmw_comm + "positions/ ",
  },
  orderPlacement: {
    quote: config.jmw + config.jmw_content + "quote/scrip/",
    holding: config.jmw + config.jmw_eq_eq + "holdings/relevance/",
    schemeDetailsMf: config.web_mw + "dion/SchemeDetails",
    schemeMf: config.web_mw + "MutualFund/Scheme/",
    holdingMf: config.jmw + config.jmw_mf + "holding/",
    quoteNfo: config.web_mw + "dion/GetSchemeDetailsForPurchase/",
    quoteExtraNfo: config.web_mw + "ipo/getNFOspecificDetails/",
  },
  limits: {
    equity: config.jmw + config.tradeService + "Limits/RMSSubLimits/1.0.0",
    comm: config.jmw + config.jmw_comm + "limits/",
  },
  holding: {
    equityUsable: config.jmw + config.jmw_eq_eq + "holdings/v1/rmsholdings/",
    equityUnusable: config.jmw + config.jmw_eq_eq + "holdings/elssholdings/",
    equitySmallcase: config.web_mw + "SmallCase/GetUserInvestment",
    mf: config.jmw + config.jmw_mf + "holding/",
  },
  marginFiles: {
    marginFiles: config.web_mw + "margintradingfiles/getdata",
  },
  broking: config.web_mw + "Broking/",
  oyo: config.web_mw + "Oyo/",
  rmDetails: config.web_mw + "RMRating/getRMCommonData",
  general: {
    enumMaster: config.moui + "eco/get-enum-list",
    areaDetails: config.moui + "eco/get-area",
    fullAddressDetails: config.moui + "eco/get-fulladdress",
    distinctBanklist: config.moui + "eco/get-distinct-bank-list",
    bankListForIfsc: config.moui + "eco/get-bank-list-for-ifsc",
    bankCities: config.moui + "eco/get-bank-cities",
    bankBranch: config.moui + "eco/get-bank-branch",
    beneficiaryNamePichain: config.moui_penny_drop + "get-beneficiary-name-pichain",
    saveBankDetails: config.moui + "eco/save-bank-details",
    BankDetails: config.moui + "eco/get-bank-details",
    generateAccessToken: config.moui + "eco/generateAccessToken",
    getDocListFromDigilocker: config.moui + "eco/getDocListFromDigilocker",
    getSelectedDocument: config.moui + "eco/getSelectedDocument",
    getExtractCheque: config.moui + "eco/extractcheque",
    getExtractaadhaarDetails: config.moui + "eco/extractaadhaar",
    getExtractVoterIDDetails: config.moui + "eco/extractvoterid",
    getExtractPassportDetails: config.moui + "eco/extractpassport",
    getExtractDLDetails: config.moui + "eco/extractdl",
    maskAadhaarLDetails: config.moui + "eco/maskaadhaar",
  },
};

const urlConfig = {
  // Add common config values here
  ...configURL,
};

export default urlConfig;